import React from "react";
import { Namespace, ParseKeys, TFunction } from "i18next";
import { Trans } from "react-i18next";

// Trans's own typings recurse too deeply on TS 4.9 with typed resources.
const LooseTrans = Trans as unknown as React.FC<Record<string, unknown>>;

interface RichTextProps<N extends Namespace> {
  t: TFunction<N>;
  /** A key in `t`'s namespace whose value uses `<tag>…</tag>` markup. */
  i18nKey: ParseKeys<N>;
  /**
   * Elements for each tag, e.g. `{ a: <a href="…" /> }`. Never name a tag
   * after a void HTML element (`link`, `br`…): its text renders outside it.
   */
  components: Record<string, React.ReactElement>;
  values?: Record<string, unknown>;
}

/** A translated string with links or emphasis inside it. */
const RichText = <N extends Namespace>({
  t,
  i18nKey,
  components,
  values,
}: RichTextProps<N>) => (
  <LooseTrans t={t} i18nKey={i18nKey} components={components} values={values} />
);

export default RichText;
